import React from "react";
import { Box } from "@chakra-ui/react";
import Navbar from "../components/Navbar";
import MapInspectionComponent from "../components/MapInspection";

const DashboardInspection = () => {
  return (
    <Box h="100vh" display="flex" flexDirection="column">
      <Navbar />
      <Box flex="1" zIndex={1}>
        <MapInspectionComponent />
      </Box>
    </Box>
  );
};

export default DashboardInspection;
